import React, { useState, useEffect, useRef } from 'react';
import { Autocomplete } from '@material-ui/lab';
import { TextField } from '@material-ui/core';
import Papa from 'papaparse'; // CSV parsing library
import debounce from 'lodash/debounce';
import { BASENAME } from '../../../constants';

const CourseInput = ({ handleAddCourse }) => {
    const [inputValue, setInputValue] = useState('');
    const [options, setOptions] = useState([]);

    const previousController = useRef();

    // Debounced search function to limit API calls for autocomplete
    const debouncedGetData = useRef(debounce(async (searchTerm) => {
        try {
            if (previousController.current) {
                previousController.current.abort();
            }
            const controller = new AbortController();
            const signal = controller.signal;
            previousController.current = controller;

            const res = await fetch(`${BASENAME}/api/courses/search?q=${encodeURIComponent(searchTerm)}`, {
                signal,
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
            });

            if (!res.ok) {
                throw new Error(`HTTP error! status: ${res.status}`);
            }
            const data = await res.json();
            setOptions(data);
        } catch (error) {
            console.error('Error fetching courses:', error);
        }
    }, 300)).current;

    const handleOptionSelect = (event, value) => {
        setInputValue('');
        setOptions([]);
        handleAddCourse(value);
    };

    useEffect(() => {
        if (inputValue.length % 2 === 0 && inputValue.length > 0) {
            debouncedGetData(inputValue);
        } else if (inputValue.length === 0) {
            setOptions([]);
        }
    }, [inputValue, debouncedGetData]);

    const handleInputChange = (event, value) => {
        setInputValue(value);
    };

    const handleCsvUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            Papa.parse(file, {
                complete: (result) => {
                    console.log('result', result.data);
                    const [header, ...rows] = result.data
                    const parsedCourses = rows.map(row => ({courseName:row[0]+row[1]}));
                    handleAddCourse(parsedCourses);
                },
                header: false
            });
        }
    };

    return (
        <div>
            <Autocomplete
                id="course-search-autocomplete"
                options={options}
                value={null}
                inputValue={inputValue}
                onInputChange={handleInputChange}
                getOptionLabel={(option) => option.courseName || ''}
                onChange={handleOptionSelect}
                style={{ width: 300 }}
                renderInput={(params) => (
                    <TextField {...params} label="Add Course" variant="outlined" />
                )}
            />

            {/* csv file input for bulk course add */}
            <input
                type="file"
                accept=".csv"
                onChange={handleCsvUpload}
                style={{ marginTop: '20px' }}
            />
        </div>
    );
};

export default CourseInput;
